module.exports = __webpack_public_path__ + "media/images/company-logos/sgdv-ssdv-logo-a0c476a36c77fb60b43d3658df8844a3.jpg";